import React from 'react';

export const PropertyTypeGroupPropertyType = ({
  propertyTypeGroupInPropertyType,
  handlePropertyType,
  propertyTypeId,
}) => {
  return (
    <div className="mt-4">
      {propertyTypeGroupInPropertyType && (
        <label className="h5 mb-2">Property Type: </label>
      )}
      <div className="form-group d-flex flex-wrap align-items-stretch">
        {propertyTypeGroupInPropertyType &&
          propertyTypeGroupInPropertyType &&
          React.Children.toArray(
            propertyTypeGroupInPropertyType?.map((propertyType) => (
              <>
                <div
                  className={`button-belair col-6 mb-0 mt-0 ${
                    // eslint-disable-next-line eqeqeq
                    propertyTypeId == propertyType?.id ? 'blend' : ''
                  }`}
                  onClick={handlePropertyType}
                  data-propertytype={propertyType?.id}
                >
                  {propertyType?.text}
                </div>
              </>
            )),
          )}
      </div>
    </div>
  );
};
